import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  public referralPageData = new BehaviorSubject<any>({});
  public referralPageData$ = this.referralPageData.asObservable();

  constructor(
    private http: HttpClient
  ) { }

  validateReferralCode(referralCode): Observable<any> {
    return this.http.get(`${environment.endPoint}/Account/SendOtp/` + referralCode)
      .pipe(
        map(res => res)
      );
  }
  validateOTP(referralCode, otp): Observable<any> {
    console.log(referralCode, otp);
    return this.http.get(`${environment.endPoint}/Account/VerifyOtp/` + referralCode + '?otp=' + otp)
      .pipe(
        map(res => res)
      );
  }

  forgetReferral(EmailId): Observable<any> {
    return this.http.get(`${environment.endPoint}/Account/ForgotReferralCode?email=${EmailId}`)
      .pipe(
        map(res => res)
      );
  }
}
